import { useState, useEffect } from 'react';
import { Box, Text, HStack, VStack } from '@chakra-ui/react';

const CountdownTimer = () => {
  const calculateTimeLeft = () => {
    const targetDate = new Date('2025-05-26T23:59:59-03:00');
    const difference = targetDate - new Date();

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const TimeUnit = ({ value, label }) => (
    <VStack
      spacing={1}
      bg="white"
      p={4}
      rounded="xl"
      shadow="md"
      minW="80px"
      justify="center"
    >
      <Text fontSize="2xl" fontWeight="bold" color="blue.500">
        {value}
      </Text>
      <Text fontSize="sm" color="gray.600">
        {label}
      </Text>
    </VStack>
  );

  return (
    <Box w="full" py={6} px={4} bg="gray.50" rounded="xl" shadow="sm">
      <Text textAlign="center" fontSize="lg" fontWeight="medium" color="gray.700" mb={4}>
        Esta capacitación ha finalizado.
      </Text>
      <HStack spacing={4} justify="center" wrap="wrap">
        <TimeUnit value={timeLeft.days} label="Días" />
        <TimeUnit value={timeLeft.hours} label="Horas" />
        <TimeUnit value={timeLeft.minutes} label="Minutos" />
        <TimeUnit value={timeLeft.seconds} label="Segundos" />
      </HStack>
    </Box>
  );
};

export default CountdownTimer;
